import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.33325 8.49341L5.41992 12.5801",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.41992 12.58L14.6666 3.33337",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgChecked;
